// extracted by mini-css-extract-plugin
export var container = "_3j-0";
export var icon = "_3j-1";
export var text = "_3j-2";